module.exports = __webpack_public_path__ + "img/premium_ticket.24f0f7cb.png";